import React, { FunctionComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal, Header } from 'semantic-ui-react';
import withStyles from 'react-jss';
import { compose } from 'recompose';
import classnames from 'classnames';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { path } from 'ramda';

import { WithRouterProps, ClassProp } from 'helpers/types';
import { useMutation } from 'helpers/useMutation';
import { CardNetwork } from 'scenes/CSVExport/CSVExport.helper';

import styles from './AddCNIDModal.styles';
import ADD_MANUAL_ON_VENUE_TO_CNID_MAPPING from './AddCNIDModal.mutations';

type Styles = ClassProp<ReturnType<typeof styles>>;

type FormData = {
  vsid: string;
};

type Props = WithRouterProps & {
  classes: Styles;
  trigger: any;
  title: string;
  cardNetwork: CardNetwork;
  label: string;
  cardNetworkExternalIdType: string;
};

const AddCNIDModal: FunctionComponent<Props> = ({
  match,
  trigger,
  title,
  classes,
  cardNetwork,
  label,
  cardNetworkExternalIdType,
}) => {
  const { runMutation, loading } = useMutation(
    ADD_MANUAL_ON_VENUE_TO_CNID_MAPPING,
    {},
    'It has been successfully processed.',
    [
      {
        key: 'not supported yet',
        newError: {
          displayMessage: 'Warning',
          message: 'We could not find this cnvenue',
        },
      },
    ],
  );

  const { register, handleSubmit, errors } = useForm<FormData>();

  const onSubmit = async ({ vsid }: FormData) => {
    runMutation({
      variables: {
        params: {
          cardNetwork,
          cardNetworkExternalIdType,
          cardNetworkExternalId: vsid,
          onvenueUuid: path(['params', 'venueId'], match),
          basis: 'PLACE_MATCH',
        },
      },
    });
  };

  return (
    <Modal trigger={trigger} closeIcon size="mini">
      <Header className={classes.header} icon="upload" content={title} />

      <Modal.Content>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={classes.fieldGroup}>
            <label className={classes.label}>{label}</label>

            <input
              className={classes.input}
              name="vsid"
              type="text"
              ref={register({ required: true })}
            />

            <ErrorMessage
              errors={errors}
              name="vsid"
              render={({ message }) => (
                <span className={classes.message}>{message}</span>
              )}
            ></ErrorMessage>
          </div>

          <div className={classes.fieldGroup}>
            <input
              disabled={loading || !!errors.vsid}
              type="submit"
              value={loading ? 'Loading...' : 'Submit'}
              className={classnames(classes.submit, {
                [classes.disabled]: loading || !!errors.vsid,
              })}
            />
          </div>
        </form>
      </Modal.Content>
    </Modal>
  );
};

export default compose<Props, any>(
  withRouter,
  withStyles(styles),
)(AddCNIDModal);
